import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ZoomOut = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19 14H11C10.448 14 10 14.448 10 15C10 15.552 10.448 16 11 16H19C19.552 16 20 15.552 20 15C20 14.448 19.552 14 19 14Z" />
		<path d="M27.708 26.294C27.708 26.294 24.761 23.347 23.45 22.036C25.042 20.128 26.001 17.674 26.001 15.001C26.001 8.93598 21.066 4.00098 15.001 4.00098C8.93598 4.00098 4.00098 8.93598 4.00098 15.001C4.00098 21.066 8.93598 26.001 15.001 26.001C17.674 26.001 20.128 25.042 22.036 23.45C23.348 24.761 26.294 27.708 26.294 27.708C26.475 27.889 26.725 28.001 27.001 28.001C27.553 28.001 28.001 27.553 28.001 27.001C28.001 26.725 27.889 26.475 27.709 26.295L27.708 26.294ZM5.99998 15C5.99998 10.037 10.037 5.99998 15 5.99998C19.963 5.99998 24 10.037 24 15C24 19.963 19.963 24 15 24C10.037 24 5.99998 19.963 5.99998 15Z" />
	</svg>
);

export default ZoomOut;
